import { Type } from "class-transformer";
import { OrderPaymentType } from "../common/order-payment-kind";
import { OrderPaymentDTO } from "./order-payment.dto";

export class OrderPaymentSummaryDTO {
	public totalAmount: number;
	public paidAmount: number;
	public pendingAmount: number;
	public isPaid: boolean;
	@Type(() => OrderPaymentDTO) public payments: OrderPaymentDTO[];
	public paymentType: OrderPaymentType;
}